<!--解决微信扫码重定向不跳转的问题，额外定义一个空路由做中转-->
<script>
export default {
  name: "RedirectLogin",
  created() {
    this.$router.replace(`/login?code=${this.$route.query.code}`);
  },
};
</script>
